import React from 'react'
import { BlogTag, TagId } from 'entities/tag'
import { NewsLetterState } from 'containers/blogs/components/newsletter/types'
import { Tags } from 'components/tags/Tags'

export const NewsLetterTags = ({
    tags,
    state,
    collapsedTagCount,
    handleTagClick,
    handleShowMoreClick,
}: {
    tags: Pick<BlogTag, 'id' | 'label'>[]
    collapsedTagCount: number
    state: NewsLetterState
    handleTagClick: (id: TagId) => void
    handleShowMoreClick: (isExpanded: boolean) => void
}) => {
    const { selectedTagIds, currentTags } = state

    return (
        <Tags
            tags={currentTags?.map(tag => {
                return {
                    ...tag,
                    isSelected: selectedTagIds?.includes(tag.id),
                }
            })}
            handleTagClick={t => handleTagClick(t.id)}
            addShowMore={tags?.length > collapsedTagCount}
            handleShowMoreClick={handleShowMoreClick}
            // wrap props
            spacing="8px"
            // tag props
            variant="primary"
            colorScheme="secondary"
        />
    )
}
